import { usePortalStateStore } from '@/plugins/stores';
import { Ref, ref } from 'vue';
import NotificationMessage from '@/models/NotificationMessage';

export default {
  name: 'TimeOutAlert',
  props: ['notificationMessage'],
  setup(props: Record<string, NotificationMessage>) {
    const portalStateStore = usePortalStateStore();
    const updateMessages = (uuid: string) => {
      portalStateStore.$patch({
        notificationMessages: portalStateStore.notificationMessages.filter((item) => item.uuid !== uuid)
      });
    };
    const notificationMessageValue = ref(props.notificationMessage) as Ref<NotificationMessage>;
    return {
      portalStateStore,
      updateMessages,
      notificationMessageValue
    };
  }
};
